import React from 'react';
import { Link } from 'react-router-dom';

import { H3Text, TitleMediumText } from '@prisjakt/ui/text/variants';
import Rating from 'src/components/rating';
import Currency from '@prisjakt/ui-currency';
import { ProductAlertFormData } from '../../types';

import * as S from './styles';

interface ProductAlertInfoProps {
  productAlertFormData: ProductAlertFormData;
}

export const ProductAlertInfo = (props: ProductAlertInfoProps) => {
  const { productAlertFormData } = props;
  const product = productAlertFormData.product;

  return (
    <S.ProductAlertInfo>
      {product?.media.first && (
        <Link to={product.pathName}>
          <S.ProductInfoImage src={product.media.first} alt={product.name} />
        </Link>
      )}
      <S.ProductInfoName>
        <H3Text>
          {product?.pathName && (
            <Link to={product.pathName}>{product?.name}</Link>
          )}
          {!product?.pathName && <span>{product?.name}</span>}
        </H3Text>
        <Rating
          hide={product?.userReviewSummary.count === 0}
          count={product?.userReviewSummary.count}
          rate={product?.userReviewSummary.rating}
          showCounter
          showRate
        />
      </S.ProductInfoName>
      {!!product?.priceSummary.regular && (
        <TitleMediumText>
          <Currency price={product?.priceSummary.regular} />
        </TitleMediumText>
      )}
    </S.ProductAlertInfo>
  );
};
